const autoTutorSentences = {
  ACT_English: {
    "Writer's Goal":
      "Improve your students' ability to evaluate whether or not a passage accomplished the author's goal.",
    "Identify Purpose":
      "Improve your students' ability to analyze the impact of the addition or deletion of sentences in an essay.",
    Relevance:
      "Review with your students how to identify and eliminate or improve essay elements that do not develop the author's main idea or that are not relevant to the paragraph.",
    "Accomplish Purpose":
      "Improve your students' ability to recognize words, phrases, or sentences that accomplish a stated purpose.",
    "Introductions & Conclusions":
      "Improve your students' ability to recognize strong introductions and conclusions.",
    "Paragraph Division":
      "Develop your students' ability to put words and sentences into a logical sequence and to use paragraph structure to logically group ideas in a passage.",
    Transitions:
      "Help your students make better choices about transitional words between sentences and paragraphs and show them how to choose phrases that present an author's thoughts in a smooth and logical flow, thereby improving their English scores.",
    Conjunctions:
      "Develop your students' ability to recognize conjunctions that logically link two clauses.",
    Redundancy:
      "Instruct your students to avoid redundancy and wordiness so that they will perform at a higher level on the English test.",
    "Vague & Clumsy Writing":
      "Work with your students to avoid vague or clumsy writing that damages the logic of a sentence.",
    "Word Choice":
      "Improve your students' ability to choose words that accomplish the author's intended effect on the reader.",
    "Faulty Coordination & Subordination":
      "Instruct your students on how to properly use coordinating and subordinating conjunctions to combine clauses.",
    "Sentence Structure Disturbances":
      "Focus on your students' ability to identify and correct comma splices and run-on sentences while ensuring that all sentences are free of misplaced modifiers, misplaced relative pronouns, and misplaced participial phrases.",
    "Verb Tense & Pronoun Person":
      "Instruct your students to maintain tense and pronoun person within the context of the passage.",
    "Adjectives & Adverbs":
      "Help your students better understand proper usage of the adverb, adjective, and possessive forms of words and improve their ability to select the correct preposition to modify sentence elements.",
    "Confusing Pairs":
      'Develop your students\' awareness of commonly confused pairs of words, such as ""there"" and ""their.""',
    Idioms:
      "Improve your students' understanding of idioms in order to avoid common errors.",
    Prepositions:
      "Improve your students' awareness of idiomatically appropriate prepositions.",
    Pronouns:
      "Help your students make pronouns agree with their antecedents and avoid using homonyms of pronouns that are inappropriate to the sentence's meaning and syntax.",
    "Subject-Verb Agreement":
      "Work with your students to help them identify and correct when subjects and verbs do not agree and review the rules of verb formation.",
    "Colons & Semicolons":
      "Improve your students' understanding of the proper use of semicolons and colons.",
    "Parenthetical Elements":
      "Clarify for your students the difference in comma usage between restrictive and non-restrictive phrases, which will help improve their scores.",
    "Unnecessary Commas":
      "Instruct your students to avoid placing unnecessary commas that disrupt the flow of the sentence or between compound subjects or compound verbs. ",
    "Forming Verbs":
      "Review with your students how to properly form regular and irregular verbs into infinitives and participles.",
    "Style & Tone":
      "Improve your students' ability to recognize appropriate style and tone in the context of a passage.",
    Apostrophes:
      "Review with your students the rules for using apostrophes in contractions and for possession.",
    "Fragments & Fused Sentences":
      "Review how to identify and correct sentence fragments and fused sentences.",
    Parallelism: "Review how to maintain parallel structure in sentences.",
    "Participial Phrases":
      "Review how to correct participial phrases disrupting sentence structure.",
    "Relative Pronouns":
      "Review how to use relative pronouns to correctly form sentences.",
    "Sentence Placement":
      "Practice placing new sentences in paragraphs in the appropriate logical sequence."
  },
  ACT_Math: {
    "Complex Numbers":
      "Review with your students how to do simple operations using imaginary numbers.",
    "Exponents & Place Values":
      "Improve your students' ability to convert numbers into scientific notation.",
    Fractions:
      "Refresh your students' knowledge of basic operations using fractions.",
    Matrices:
      "Review with your students how to calculate the values of operations involving matrices.",
    Arithmetic:
      "Improve your students' ability to solve word problems by using basic mathematical operations.",
    "Creating Expressions":
      "Improve your students' ability to create expressions when given data presented in a word problem or table.",
    "Exponents & Roots":
      "Help your students' understand exponents and roots and use this information to simplify expressions or determine values.",
    Expressions:
      "Improve your students' ability to manipulate and simplify expressions.",
    "Inequalities & Absolute Value":
      "Review with your students the method of simplifying an inequality with and without the presence of absolute value.",
    "Solving Equations":
      "Improve your students' ability to solve for specific values using equations that are either given or must be determined from a word problem.",
    "Function Graphs - Modeling & Relations":
      "Help your student model functions on the coordinate plane and reason about the relationships between functions.",
    "Function Graphs - Coordinate Plane":
      "Review with your students the  features of functions and relationships between multiple functions when graphed on a coordinate plane.",
    "Functions - Understanding & Evaluating":
      "Reinforce the focus on finding the values of functions while avoiding common errors in calculation.",
    "Patterns & Sequences":
      "Review with your students the fundamentals of arithmetic and geometric sequences and patterns and how to determine the sums of those sequences and patterns.",
    "Trig Functions":
      "Review advanced trigonometric concepts with your students, including the unit circle, radians, the trig area formula, inverse trig functions, and graphing trig functions.",
    "Angles & Shapes":
      "Refresh your students' knowledge of solving for interior angles of a triangle as well as angles along parallel lines.",
    "Area, Perimeter, Volume & Circumference":
      "Review with your students how to solve problems involving area, perimeter, volume, and circumference.",
    "Circles - Plane Geometry":
      "Increase your students' grasp of the geometry of circles, including the basics of area and circumference as well as more advanced concepts like chords and interior angles.",
    "Slope, Midpoint & Distance":
      "Increase your students' understanding of equations for lines in the coordinate plane and increase their ability to determine the midpoint and distance between two points.",
    "Translation, Rotation, Reflection & Relative Equations":
      "Review with your students the process of translating, rotating, and reflecting equations on a coordinate plane.",
    Triangles:
      "Review with your students how to find the length of triangle sides using the Pythagorean Theorem and the properties of similar triangles.",
    "Trig Geometry":
      "Review with your students the Laws of Sines and Cosines and how to use their formulae to solve for the missing sides and angles of triangles.",
    "Averages, Median & Mode":
      "Refresh your students' understanding of mean, median, and mode.",
    "Data Interpretation":
      "Improve your students' ability to extract and manipulate data given in either a table or chart.",
    Probability:
      "Review with your students the fundamentals of probability with one or multiple events, including joint and conditional probability.",
    Logic:
      "Improve your students' ability to manipulate and process logical statements.",
    Factors: "Develop your students' understanding of factors and multiples.",
    "Circles & Parabolas - Coordinate Plane":
      "Review with your students conic sections and specifically the use of circles and parabolas.",
    "Locating Points":
      "Help your students recognize how to identify points in a coordinate plane from information given in a word problem.",
    "Using Formulas":
      "Develop your students' ability to apply a given formula to information in a problem.",
    "Number Concepts & Properties":
      "Improve your students' ability to apply number concepts or properties to abstract problems.",
    "Properties of Functions":
      "Develop your students' understanding of the implications of different aspects of a function."
  },
  ACT_Reading: {
    "Draw Conclusions":
      "Develop your students' ability to identify logical inferences from passage text.",
    Locate:
      "Improve your students' ability to locate specific details in a passage and to use those details to select an appropriate answer.",
    Paraphrase:
      "Help your students to discern between appropriate and inappropriate paraphrases when given passage text.",
    "Central Ideas":
      "Review with your students the process of determining the main idea or theme of passages and individual paragraphs.",
    "Summarize Key Ideas & Details":
      "Improve your students' ability to recognize a summary of specific details found in a passage.",
    "Comparative Relationships":
      "Develop your students' awareness of relationships between characters or concepts in a passage and improve their ability to describe those relationships.",
    "Analyze Word & Phrase Choices":
      "Develop your student's ability to recognize the rhetorical use of specific words or phrases found in a passage.",
    "Interpret Words & Phrases":
      "Improve your students' ability to define specific words or phrases based on the context provided by the passage.",
    Function:
      "Review with your students the structure of a passage and the method of determining the potential role of each detail or paragraph within that structure.",
    "Intent & Purpose":
      "Practice with your students identifying the author's intended purpose for using specific details or arguments within a passage.",
    "Point of View":
      "Improve your students' familiarity with common attitudes found in passages and appropriate words or phrases to describe those attitudes.",
    "Compare Two Texts":
      "Develop your students' ability to determine and articulate relationships between two separate texts.",
    "Sequence of Events":
      "Practice with your students identifying the location of an event in a sequence that is not necessarily presented chronologically.",
    "Relate to Passage as a Whole":
      "Improve your students' understanding of specific components of a passage in the context of the central theme.",
    "Conclusions Two Texts":
      "Develop your students' ability to draw conclusions from two separate but related texts.",
    "Analyze Structure":
      "Develop your students' understanding of common text structures and their ability to identify them.",
    "Central Ideas & Themes":
      "Review with your students the process of determining the main idea or theme of passages and individual paragraphs."
  },
  ACT_Science: {
    "Compare or Combine":
      "Improve your students' ability to extract and compare multiple pieces of data given by a figure.",
    "Creating Figures":
      "Practice with your students the process of creating a graph or chart based on data given in a passage or figure.",
    "Interpolation & Extrapolation":
      "Develop your students' ability to determine additional values based on a trend by analyzing a graph or chart.",
    "New Information":
      "Practice with your students the method of interpreting the effects of new information or definitions in conjunction with information given in the passage or figures.",
    "Select Data & Features":
      "Review with your students the process of reading a graph or chart in order to extract data.",
    Terminology:
      "Review with your students basic science terminology associated with the topics tested on the ACT.",
    "Variables & Mathematical Relationships":
      "Develop your student's ability to determine common trends in data and the method of establishing mathematical relationships such as equations or averages.",
    Comparison:
      "Develop your students' ability to identify differences and similarities between two or more experiments.",
    "Experimental Design":
      "Improve your students' understanding of experimental design and the purpose of particular actions taken by scientists within an experiment.",
    "Prediction & Further Experiments":
      "Practice with your students making predictions of outcomes of additional trials within an experiment based on past experimental data.",
    Text: "Review with your students the process of selecting relevant information about an experiment from passage text.",
    Tools:
      "Improve your students' understanding of scientific tools and how they are used in an experiment.",
    "Consistency of Hypotheses, Predictions & Conclusions":
      "Develop your students' ability to determine whether information is consistent with a hypothesis or experiment given in a passage.",
    "Model Information":
      "Develop your students' ability to assess models and to determine their implications.",
    "Support of Hypotheses":
      "Practice with your students determining how different hypotheses can be used to support specific statements.",
    "Understanding Design":
      "Develop your student's understanding of experimental design.",
    Hypothesis:
      "Review with your student's the definition of a hypothesis and the ability to identify it in the context of an experiment.",
    Methods:
      "Review with your students common methods used in experimentation and the reasoning behind them.",
    "Support or Weakening of Models":
      "Practice with your students determine whether given information supports or weakens a hypothesis.",
    Controls:
      "Develop your student's ability to identify the control in an experiment."
  },

  //TODO: Need new subjects for sat subjects, using defaults for now.
  "SAT_Writing and Language": {
    "Expression of Ideas": "",
    "Effective language use": "",
    Syntax: "",
    "Style and tone": "",
    Concision: "",
    Precision: "",
    Organization: "",
    "Logical sequence": "",
    "Introductions, conclusions, and transitions": "",
    Development: "",
    Support: "",
    Focus: "",
    "Quantitative information (D)": "",
    Proposition: "",
    "Standard English Conventions": "",
    "Sentence structure": "",
    "Sentence formation": "",
    "Sentence boundaries": "",
    "Parallel structure": "",
    "Subordination and coordination": "",
    "Modifier placement": "",
    "Inappropriate shifts in construction": "",
    "Pronoun person and number": "",
    "Verb tense, mood, and voice": "",
    "Conventions of usage": "",
    Agreement: "",
    "Noun agreement": "",
    "Subject-verb agreement": "",
    "Pronoun-antecedent agreement": "",
    "Logical comparison": "",
    "Conventional expression": "",
    "Frequently used words": "",
    Pronouns: "",
    "Pronoun clarity": "",
    "Possessive determiners": "",
    "Conventions of punctuation": "",
    "Unnecessary punctuation": "",
    "End-of-sentence punctuation": "",
    "Possessive nouns and pronouns": "",
    "Within-sentence punctuation": "",
    "Nonrestrictive and parenthetical elements": "",
    "Items in a series": ""
  },
  SAT_Reading: {
    Rhetoric: "",
    Purpose: "",
    "Word choice": "",
    Arguments: "",
    "Assessing reasoning": "",
    "Analyzing evidence": "",
    "Claims and counterclaims": "",
    "Analyzing purpose": "",
    "Point of view": "",
    "Text structure": "",
    "Part-whole relationships": "",
    "Overall structure": "",
    Synthesis: "",
    "Multiple texts": "",
    "Quantitative information (S)": "",
    "Information and Ideas": "",
    Summarizing: "",
    "Understanding relationships": "",
    "Interpreting words and phrases": "",
    "Central ideas and themes": "",
    "Reading closely": "",
    "Explicit meanings": "",
    "Implicit meanings": "",
    "Analogical reasoning": "",
    "Citing textual evidence": ""
  },
  SAT_Math: {
    "Passport to Advanced Math": "",
    "Nonlinear equations": "",
    "Nonlinear functions": "",
    "Equivalent expressions": "",
    "Heart of Algebra": "",
    "Linear equations, two variables": "",
    "Linear functions": "",
    "Linear equations, one variable": "",
    "Systems of equations": "",
    "Linear inequalities": "",
    "Problem Solving and Data Analysis": "",
    "Models and scatterplots": "",
    Probability: "",
    "Center and spread": "",
    "Statistical claims": "",
    Percentages: "",
    "Inference from statistics": "",
    "Rates, proportions, and units": "",
    "Additional Topics in Math": "",
    "Complex numbers": "",
    "Lines, angles, and triangles": "",
    Circles: "",
    "Right triangles and trig": "",
    "Area and volume": ""
  }
}

export default autoTutorSentences
